/* eslint-disable no-unused-vars */
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { useEffect, useState } from "react";
import axios from "axios";
import UserAddBot from "../../Admin/Modal/AddBot";

import ChatbotData from "./ChatBotData";
import ChatBotSetting from "./ChatBotSetting";
import AdminChatHistory from "../ChatHistory/AdminChatHistory";
import ChatBotInterface from "./ChatBotInterface";
import ChatBotSources from "./ChatBotSources";
import ChatBotEmbed from "./ChatBotEmbed";
// import UserBotDelete from "../../User/Modal/UserBotDelete";
import ReactTost from "../../ReactTost";
import UserCreateBot from "./AdminCreateBot";
import { useTranslation } from "react-i18next";

const AdminBots = () => {
  const [tabIndex, setTabIndex] = useState("");
  const [deleteBotId, setDeleteBotId] = useState();
  const [deleteModalShow, setDeleteModalShow] = useState(false);

  const [getBots, setGetBots] = useState(true);

  const [docList, setDocList] = useState([]);

  const API_URL = process.env.REACT_APP_API_URL;
  const API_VERSION = process.env.REACT_APP_API_VERSION;
  const [type, setType] = useState("");
  const [message, setMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [botList, setBotList] = useState([]);
  const [addModalShow, setAddModalShow] = useState(false);
  const [botAll, setBotAll] = useState([]);
  const { id, bot } = useParams();
const[sellerId,setSellerId]=useState('');
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
   
    axios
      .get(`${API_URL}/${API_VERSION}/user/${id}`, {
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
      
        if(response.data.seller)
        {
          setSellerId(response.data.seller)
        }
        
        
      })
      .catch((error) => {
      
        setType("Danger");
        setMessage(t("Something went to wrong."));
        setShowAlert(true);
      });
   
  }, [id, API_URL, API_VERSION]);
  const getAllBots = async () => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${API_URL}/${API_VERSION}/bot/user/${id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        })
        .then((response) => {
          setBotList(response.data);

          setGetBots(false);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const fetchData = async () => {
    try {
      const response = await axios.get(
        `${API_URL}/${API_VERSION}/user_doc?id=${id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      setDocList(response.data.results);
    } catch (error) {
      console.error(error);
    }
  };

  function createBot(data) {
    if (data && id) {
      axios
        .put(
          `${API_URL}/${API_VERSION}/bot`,
          {
            name: data,
            user: id,
            settings: {
              prompt:
                "You are a helpful AI assistant. Use the following pieces of context to answer the question at the end. If you don't know the answer, just say you don't know. DO NOT try to make up an answer. If the question is not related to the context, politely respond that you are tuned to only answer questions that are related to the context.",
              model: "gpt-3.5-turbo",
              temperature: 0,
              // messageCount: 20,
              messageLimit: 100,
              visibility: "private",
            },
            chatInterface: {
              logoName: "https://seekicon.com/free-icon-download/chat_7.svg",
            },
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        )
        .then((response) => {
          setTimeout(() => {
            navigate(`/admin/my-bots/${id}/${response.data.botId}`);
          }, 1000);
          setGetBots(true);
          setBotList((prevBotList) => {
            const newBotList = [...prevBotList, response.data];
            return newBotList;
          });
          setType("Success");
          setMessage(t("Your bot is created."));
          setShowAlert(true);
        })
        .catch((error) => {
          setType("Danger");
          setMessage("Something went to wrong.");
          setShowAlert(true);
        });
    }
  }

  const callGetBot = async (selectedId) => {
    if (selectedId) {
      axios
        .get(`${API_URL}/${API_VERSION}/bot/${selectedId}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        })
        .then((response) => {
          setBotAll((prevBotAll) => ({
            ...prevBotAll,
            id: response.data,
          }));
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  useEffect(() => {
    getAllBots();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bot]);

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (botList && bot) {
      const selectedId = botList.findIndex((b) => {
        const myId = JSON.stringify(b.id) === JSON.stringify(bot);
        return myId;
      });

      setTabIndex(selectedId);
      callGetBot(bot);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [botList]);

  return (
    <>
      {botList.length === 0 ? (
        <UserCreateBot />
      ) : (
        <section className="creatnewbot userbots_main admin_bot">
          <ReactTost
            onHide={() => {
              setShowAlert(false);
              setType("");
              setMessage("");
            }}
            alertClass={type}
            alertMessage={message}
            alertDo={showAlert}
          />
          <Container>
            <Row>
              <Col>
              {/* {sellerId ? <Link className="button" to={`/admin/manager/user/${sellerId}`}>
              <i className="fa-solid fa-arrow-left"></i> Back
            </Link>
              :

              <Link className="button" to="/admin/clients">
              <i className="fa-solid fa-arrow-left"></i> {t("Back")}
            </Link>} */}
                
                <Tabs
                  onSelect={(index) => setTabIndex(index)}
                  selectedIndex={tabIndex}
                >
                  <Row>
                    <Col lg={3}>
                      <div className="scrollsticky">
                        <div className="addbtn">
                          <Link
                            className="userbutton"
                            onClick={() => setAddModalShow(true)}
                          >
                            <i className="fa-solid fa-circle-plus"></i> {t("New Chatbot")}
                          </Link>
                        </div>
                        <TabList
                          className="nav flex-lg-column nav-pills"
                          onSelect={(index) => {
                            alert(botList[index].id);
                          }}
                        >
                          {botList &&
                            botList.map((bot, index) => {
                              const counter =
                                index < 9 ? `0${index + 1}` : index + 1;
                              return (
                                <Tab Tab key={index}>
                                  <Link to={`/admin/my-bots/${id}/${bot.id}`}>
                                    <div className="cardflex">
                                      <div className="cont">
                                        <div className="botname">
                                          {bot.name}
                                        </div>
                                        <div className="num">
                                          <span>{counter}</span>
                                        </div>
                                      </div>
                                    </div>
                                  </Link>
                                </Tab>
                              );
                            })}
                        </TabList>
                      </div>
                    </Col>
                    <Col lg={9}>
                      <div className="tabpanel">
                        {botAll &&
                          botList.map((bot, index) => (
                            <TabPanel className="tab-pane haschild">
                              <Tabs>
                                <TabList className="chat_bot_tab nav">
                                  <Tab>{t("Settings")}</Tab>
                                  <Tab>{t("Knowlegde Base")}</Tab>
                                  <Tab>{t("Try your bot")}</Tab>
                                  <Tab>{t("Embed on Site")}</Tab>
                                  <Tab>{t("Chatbot History")}</Tab>
                                  <Tab>{t("Chat Interface")}</Tab>
                                </TabList>
                                <TabPanel>
                                  <ChatBotSetting botData={botAll.id} />
                                </TabPanel>
                                <TabPanel>
                                  <ChatBotSources
                                    botData={botAll.id}
                                    docData={docList ? docList : []}
                                  />
                                </TabPanel>
                                <TabPanel>
                                  <ChatbotData botData={botAll.id} />
                                </TabPanel>
                                <TabPanel>
                                  <ChatBotEmbed botData={botAll.id} />
                                </TabPanel>
                                <TabPanel>
                                  <AdminChatHistory />
                                </TabPanel>
                                <TabPanel>
                                  <ChatBotInterface botData={botAll.id} />
                                </TabPanel>
                              </Tabs>
                            </TabPanel>
                          ))}
                      </div>
                    </Col>
                  </Row>
                </Tabs>
              </Col>
            </Row>
          </Container>
        </section>
      )}
      <UserAddBot
        show={addModalShow}
        onHide={() => setAddModalShow(false)}
        createBot={createBot}
      />
      
      {/* <UserBotDelete
        show={deleteModalShow}
        deleteBotId={deleteBotId}
        getBots={getBots}
        onHide={() => {
          setDeleteModalShow(false);
        }}
      /> */}
    </>
  );
};
export default AdminBots;
